import React from "react";
import "../../css/aboutMe.css";

class QuoteBlock extends React.Component {
  render() {
    return (
      <div className="quote-block">
        <blockquote>
          “Once you learn the way broadly, you will see it in all things!”
        </blockquote>
        <p className="quote-attribution">
          — Miyamoto Musashi (Legendary Japanese swordsman, philosopher, and
          strategist from 17th century)
        </p>
      </div>
    );
  }
}

export default QuoteBlock;
